import { hairline } from "../utils";
import { type SizeLegacyKeys, sizeLegacy } from "./legacy/token-size";

export const iconSizeTokens = {
  iconXSmall: 12,
  iconSmall: 16,
  iconMedium: 20,
  iconLarge: 24,
  iconXLarge: 32,
} as const;

export const borderSizeTokens = {
  border1: hairline,
  border2: 1,
} as const;

export type IconSizeKey = keyof typeof iconSizeTokens;
export type IconSizeToken = `$${IconSizeKey}`;

export const sizeTokens = {
  si0: 0,
  "si0.5": 4,
  si1: 8,
  "si1.5": 12,
  si2: 16,
  "si2.5": 20,
  si3: 24,
  si4: 32,
  si5: 40,
  si6: 48,
  si7: 56,
  si8: 64,
  si9: 72,
  si10: 80,
  si11: 88,
  si12: 96,

  ...iconSizeTokens,
  ...borderSizeTokens,
} as const;

export type SizeTokensKeys = keyof typeof sizeTokens;

// Combined export for backward compatibility
export const size: typeof sizeTokens & typeof sizeLegacy = {
  ...sizeLegacy,
  ...sizeTokens,
};

export type SizeKeysIn = keyof typeof size;

// Helper type to strip $ prefix (distributive over union)
type StripDollarPrefix<T> = T extends `$${infer Key}` ? Key : T;

export type Sizes = {
  [Key in SizeKeysIn as StripDollarPrefix<Key>]: number;
};

export type SizeKeys = SizeTokensKeys | SizeLegacyKeys;
